import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotebookService } from '../services/notebook.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ConsumptionService } from '../services/consumption.service';
import { DEFAULT_MAX_USER_USAGE } from '../config/notebook-config';
import { UserUsage } from '../interfaces/user-usage';


@Component({
  standalone: true,
    selector: 'app-consumption',
    imports: [CommonModule],
    templateUrl: './consumption.component.html',
    styleUrls: ['./consumption.component.css']
})
export class ConsumptionComponent implements OnInit, OnDestroy {
  readonly maxAllowedUsage = DEFAULT_MAX_USER_USAGE;
  usage$!: Observable<UserUsage>;
  maxUsage!:UserUsage;

  quotaUsed$!: Observable<{
    cpu: { label: string; width: string },
    ram: { label: string; width: string },
    storage: { label: string; width: string }
  }>;

  constructor(
    private notebookService: NotebookService,
    private router: Router,
    private consumptionService: ConsumptionService
  ) {}

  ngOnInit(): void {
    // Init usage 
    this.consumptionService.initUsage(this.notebookService);
    this.consumptionService.initQuotaMonitoring(this.notebookService);
    this.usage$ = this.consumptionService.getCurrentUsage$();
    this.quotaUsed$ = this.consumptionService.getQuotaUsed$();
    this.maxUsage = this.consumptionService.getMaxAllowedUsage();
   // console.log("max Storage: ", this.maxUsage.storage);
  }


  ngOnDestroy(): void {
    this.consumptionService.cleanupQuotaMonitoring();
  }

  goHomepage(): void {
    this.router.navigateByUrl('/list');
  }
}
